import { render, staticRenderFns } from "./payment_follow_up_row.vue?vue&type=template&id=df48deb8&"
import script from "./payment_follow_up_row.vue?vue&type=script&lang=js&"
export * from "./payment_follow_up_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports